import { createStore } from "vuex";
import api from "@/api/api";

export default createStore({
  state: {
    products: [],
    categories: [],
    productsLoading: false,
    productsError: null
  },
  mutations: {
    SET_PRODUCTS(state, products) {
      state.products = products;
    },
    SET_CATEGORIES(state, categories) {
      state.categories = categories;
    },
    SET_PRODUCTS_LOADING(state, value) {
      state.productsLoading = value;
    },
    SET_PRODUCTS_ERROR(state, error) {
      state.productsError = error;
    }
  },
  actions: {
    async fetchProducts({ commit }) {
      commit("SET_PRODUCTS_LOADING", true);
      commit("SET_PRODUCTS_ERROR", null);
      try {
        const { data } = await api.get("/products/catalog");
        commit("SET_PRODUCTS", data);
      } catch (err) {
        console.error("Ошибка при загрузке товаров:", err);
        commit(
          "SET_PRODUCTS_ERROR",
          err.code === "ECONNABORTED"
            ? "Сервер долго не отвечает. Проверьте интернет и попробуйте ещё раз."
            : "Не удалось загрузить товары. Попробуйте ещё раз."
        );
      } finally {
        commit("SET_PRODUCTS_LOADING", false);
      }
    },

    async fetchCategories({ commit }) {
      try {
        const { data } = await api.get("/products/categories/");
        const categories = [{ name: "Все" }, ...data];
        commit("SET_CATEGORIES", categories);
      } catch (err) {
        console.error("Ошибка при загрузке категорий:", err);
      }
    },

    async searchProducts({ commit, dispatch }, query) {
      if (!query) {
        return await dispatch("fetchProducts");
      }
      try {
        const { data } = await api.get(`/products/search/?q=${encodeURIComponent(query)}`);
        commit("SET_PRODUCTS", data);
      } catch (err) {
        console.error("Ошибка при поиске товаров:", err);
      }
    },

    async fetchAll({ dispatch }) {
      await Promise.all([
        dispatch("fetchProducts"),
        dispatch("fetchCategories")
      ]);
    }
  }
});